import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { InternalLinks } from '../../../../constants';
import { ClickLiveChatButton } from './click-live-chat-button';

export const LiveChat = ({ firstName, myAcuvueId }: {
  firstName?: string;
  myAcuvueId?: string;
}): JSX.Element => {
  const navigate = useNavigate();
  const vScript = 'https://widget.voxys.ru/ChatAPI';
  const vGuid = process.env.REACT_APP_VOXYS_GUID || '';
  const vId = process.env.REACT_APP_VOXYS_ID || '';

  useEffect(() => {
    const styles = document.createElement('style');
    styles.innerHTML = 'html, body { height: 100%; margin: 0 } .omnivox-ChatHeader-Box-3 {' +
      ' display: none }';
    document.head.appendChild(styles);
  }, []);

  useEffect(() => {
    if (!(firstName && myAcuvueId)) {
      navigate(InternalLinks.home);
      return;
    }

    const vKey = 'voxys_pre_client';
    window.localStorage.setItem(
      vKey,
      JSON.stringify({
        firstName,
        lastName: myAcuvueId,
      }),
    );

    const vElem = document.querySelector(`#${vId}`);

    // Programmatically add the external script to ensure it loads in prod-like environments
    const scriptUrl = `${vScript}/widget/assets/js/main.widget.js`;

    // Remove existing script if present, then add a fresh one
    const existing = document.querySelector(`script[src="${scriptUrl}"]`);
    let scriptEl: HTMLScriptElement | null = null;

    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }

    scriptEl = document.createElement('script');
    scriptEl.src = scriptUrl;
    scriptEl.async = true;
    scriptEl.crossOrigin = 'anonymous';
    scriptEl.referrerPolicy = 'no-referrer';

    scriptEl.addEventListener('load', () => {
      console.debug('LiveChat widget script loaded');
    });

    scriptEl.addEventListener('error', () => {
      console.error('Failed to load LiveChat widget script');
    });

    if (vElem && window.localStorage.getItem(vKey)?.length) {
      document.head.appendChild(scriptEl);
    }


    return () => {
      if (scriptEl?.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }

      if (window.localStorage.getItem(vKey)) {
        window.localStorage.removeItem(vKey);
      }
    };
  }, [firstName, myAcuvueId, navigate, vScript, vId]);

  return (
    <>
      <div
        id={vId}
        data-omnivox-guid={vGuid}
        data-omnivox-project="JohnsonWidgetMobile"
        data-omnivox-script={vScript}
      />
      <ClickLiveChatButton vId={vId} />
    </>
  );
};
